import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { BookWidgetFieldsMasterConfig } from '../../models/book-widget-fields-master-config.interfaces';
import { SavedTripList } from '../../models/core-apis/saved-search.interfaces';
import { updateAirportsFieldFromSavedSearch } from './saved-search-airports-field.adapter';
import { updatePassengerFieldFromSavedSearch } from './saved-search-passenger-field.adapter';
import { updateBestFareFieldFromSavedSearch } from './saved-search-best-fare-field-adapter';
export const updateFieldsFromSavedSearch = (
  savedTripList: SavedTripList[] | null,
  index: number,
  bookWidgetFields: BookWidgetFields,
  bookWidgetFieldsMasterConfig: BookWidgetFieldsMasterConfig
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (savedTripList?.length) {
    const savedSearchData = savedTripList[index];

    updatedBookWidgetFields = updateAirportsFieldFromSavedSearch(
      savedSearchData,
      updatedBookWidgetFields
    );

    updatedBookWidgetFields = updatePassengerFieldFromSavedSearch(
      savedSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );
    updatedBookWidgetFields = updateBestFareFieldFromSavedSearch(
      savedSearchData,
      updatedBookWidgetFields,
      bookWidgetFieldsMasterConfig
    );
  }

  return updatedBookWidgetFields;
};
